import {observer} from 'mobx-react';
import {Switch, Route} from 'react-router-dom';
import AbsoluteRedirect from 'shared/components/AbsoluteRedirect';
import PendingRequestsList from './PendingRequestsList';

const PendingRequestPage = observer(({match, scope}) => {
  return (
    <Switch>
      <Route exact path={match.path} render={({history, match}) => <PendingRequestsList match={match} history={history} scope={scope}/>} />
      <Route path={`${match.path}/:id`} render={({match, location}) => <AbsoluteRedirect path={`/time_off/requests/${match.params.id}${location.search}`}/>}/>
    </Switch>
  );
});

export default PendingRequestPage;
